import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.map.js";
/* eslint-disable react/prop-types */
import React from 'react';
import { branch, compose, renderNothing, withProps } from 'recompose';
import FontAwesome from 'react-fontawesome';
import { formattedFileSize } from '@applyboard/ui-utils';
import { API_ROOT } from "../../../../constants/consts";
var enhancer = compose(branch(function (_ref) {
  var attachment = _ref.attachment;
  return !attachment;
}, renderNothing), withProps(function (_ref2) {
  var attachment = _ref2.attachment;
  var fontAwesomeName;
  var pieces = attachment.content_type.split('/');
  switch (pieces[pieces.length - 1].toLowerCase()) {
    case 'plain':
    case 'txt':
      fontAwesomeName = 'file-text-o';
      break;
    case 'msword':
    case 'doc':
    case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
      fontAwesomeName = 'file-word-o';
      break;
    case 'vnd.ms-excel':
    case 'xls':
    case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      fontAwesomeName = 'file-excel-o';
      break;
    case 'png':
    case 'jpg':
    case 'jpeg':
      fontAwesomeName = 'file-image-o';
      break;
    case 'pdf':
      fontAwesomeName = 'file-pdf-o';
      break;
    default:
      fontAwesomeName = 'file-o';
  }
  return {
    fontAwesomeName: fontAwesomeName
  };
}));
var SingleAttachment = function SingleAttachment(_ref3) {
  var attachment = _ref3.attachment,
    fontAwesomeName = _ref3.fontAwesomeName;
  return /*#__PURE__*/React.createElement("a", {
    className: "additional-attachment",
    href: "".concat(API_ROOT).concat(attachment.link),
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: fontAwesomeName
  }), attachment.file_name, " (", formattedFileSize(attachment.file_size), ")");
};
var EnhancedSinglAttachment = enhancer(SingleAttachment);
var AdditionalAttachments = function AdditionalAttachments(_ref4) {
  var attachments = _ref4.attachments;
  return /*#__PURE__*/React.createElement(React.Fragment, null, attachments && attachments.map(function (attachment) {
    return /*#__PURE__*/React.createElement(EnhancedSinglAttachment, {
      attachment: attachment,
      key: attachment.id
    });
  }));
};
export default AdditionalAttachments;